module.exports = __webpack_public_path__ + "img/lithuania.39c12cc.webp";